import type { ViewProps } from "@phoenix/components";
import { DebouncedSearch, Flex, View } from "@phoenix/components";
import { useEvaluatorsFilterContext } from "@phoenix/pages/evaluators/EvaluatorsFilterProvider";

export const EvaluatorsFilterBar = ({
  extraActions,
  padding = "size-200",
}: {
  extraActions?: React.ReactNode;
  padding?: ViewProps["padding"];
}) => {
  const { setFilter, filter } = useEvaluatorsFilterContext();

  return (
    <View
      padding={padding}
      borderBottomWidth="thin"
      borderBottomColor="gray-200"
      flex="none"
    >
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap="size-100"
      >
        <DebouncedSearch
          aria-label="Search evaluators by name"
          onChange={setFilter}
          defaultValue={filter}
          placeholder="Search evaluators by name"
        />
        {!!extraActions && (
          <Flex direction="row" alignItems="center" gap="size-100" flex="none">
            {extraActions}
          </Flex>
        )}
      </Flex>
    </View>
  );
};
